import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const CONSULT_PATIENT = {
  labels: {
    ...COMMONS,
  },

  actions: {
    ...ACTIONS,
    editPatient: 'Editar información de paciente',
    generateHistory: 'Generar Historia'
  }
};
